import { Suspense, lazy } from 'react';
import { RouteObject } from 'react-router';

import { relativeRoutes, routes } from '@fly/shared';
import { FlyNotFound } from '@fly/shared-ui';

import { LoginCallback, SilentRenewCallback } from './components';
import { GitHubCallback } from './components/GitHubCallback/GitHubCallback';
import { GitHubConfigureRedirect } from './components/GitHubConfigureRedirect/GitHubConfigureRedirect';

const Auth = lazy(() => import('./Auth'));
const DesktopLogin = lazy(
  () => import('./components/DesktopLogin/DesktopLogin')
);

export const githubCallbackRoutes: RouteObject[] = [
  {
    path: routes.GITHUB_CALLBACK.PRE_CONFIGURE,
    element: <GitHubConfigureRedirect />,
  },
  {
    path: routes.GITHUB_CALLBACK.ROOT,
    element: <GitHubCallback />,
  },
];

export const authRoutes: RouteObject[] = [
  {
    path: `${routes.AUTH.ROOT}/*`,
    element: (
      <Suspense>
        <Auth />
      </Suspense>
    ),
    children: [
      {
        path: `${relativeRoutes.CALLBACK}`,
        element: <LoginCallback />,
      },
      {
        path: `${relativeRoutes.RENEW}`,
        element: <SilentRenewCallback />,
      },
      {
        path: `${relativeRoutes.LOGIN_DESKTOP}`,
        element: (
          <Suspense>
            <DesktopLogin />
          </Suspense>
        ),
      },
      {
        path: '*',
        element: <FlyNotFound />,
      },
    ],
  },
];
